import { defineActionGroup } from 'rd-redux-utils';

const settingsActionGroup = defineActionGroup('SETTINGS');

export const setSettingsLoadedAction = settingsActionGroup.defineAction<{
  loaded: boolean;
}>('SET LOADED');
